// extracted by mini-css-extract-plugin
export var container = "_qf-0";
export var table = "_qf-2";
export var tableWrapper = "_qf-1";